import { z } from "zod";

export const getUserRolesCreateFormModelSchema = () => {
	return z.object({
		name: z.string().nonempty({ message: "Name of the role is required" }),
		permissions: z.array(z.string()),
	});
};

export type UserRolesCreateFormModel = z.infer<
	ReturnType<typeof getUserRolesCreateFormModelSchema>
>;
